import { http } from '../rest';

export function fetchActivityReport(http, demo) {
  return {
    async execute(clientId, timeSpan) {
      if (demo) {
        const file = await import('./fetchClientActivityReport.data');
        return file.default();
      }
      const response = await http.get(`/clients/${clientId}/download/transactions${timeSpan}`);
      return response.data;
    },
  };
}

export default fetchActivityReport(http, process.env.DEMO);
